module.exports = __webpack_public_path__ + "static/media/one-block--anim.59dba519.svg";